import { getStockJournalPermissions } from "../../../services/auth/permission";

export default {
    namespaced: true,
    state: {
        stockAdjustment: {
            list: false,
            read: false,
            create: false,
            update: false,
            delete: false,
            post: false
        },
        goodsReceipt: {
            list: false,
            read: false,
            create: false,
            update: false,
            delete: false
        },
        goodsIssue: {
            list: false,
            read: false,
            create: false,
            update: false,
            delete: false
        }
    },
    getters: {
        stockAdjustment: state => state.stockAdjustment,
        goodsReceipt: state => state.goodsReceipt,
        goodsIssue: state => state.goodsIssue
    },
    mutations: {
        set(state, payload) {
            state.stockAdjustment = payload.stock_adjustment;
            state.goodsReceipt = payload.goods_receipt;
            state.goodsIssue = payload.goods_issue;
        }
    },
    actions: {
        async get(context) {
            return new Promise((resolve, reject) => {
                getStockJournalPermissions()
                    .then(
                        r => {
                            context.commit("set", r.data)
                            resolve(r)
                        }
                    )
                    .catch(
                        e => reject(e)
                    )
            });
        }
    }
}